<template>
  <div>
    <p class="text-static-default-mid body-2 md:pl-40">
      {{ i18n(translations.tabProducts) }}
    </p>

    <ProductFeed :pending :products @click-product="handleProductClick" />
  </div>
</template>

<script setup lang="ts">
import { useState } from '#imports'

import type { Product } from '@backmarket/nuxt-layer-recommendation/models/product'
import { useClickTracking } from '@backmarket/nuxt-layer-recommendation/useProductTracking'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import type { SearchTrackingData } from '~/scopes/product-list/composables/useProductsSearch/useProductsSearch.types'

import ProductFeed from '../ProductFeed/ProductFeed.vue'

import translations from './ProductSection.translations'

defineProps<{
  products: Product[]
  pending: boolean
}>()

const emits = defineEmits(['click-product'])

const i18n = useI18n()

const { trackFormSubmit } = useTracking()
const { trackProductClick } = useClickTracking()
const searchTrackingData = useState<SearchTrackingData>('search-query')

function handleProductClick({
  product,
  index,
}: {
  product: Product
  index: number
}) {
  emits('click-product')
  trackFormSubmit({
    name: product.title,
    payload: { index_used: index, search_type: 'suggested_models' },
    zone: 'header_searchbar',
  })
  trackProductClick(product, {
    list: 'search',
    position: index + 1,
    queryID: searchTrackingData.value?.id,
    index: searchTrackingData.value?.index,
    provider: 'algolia',
    source: 'search',
  })
  if (searchTrackingData.value) {
    searchTrackingData.value.productObjectId = product.objectId
  }
}
</script>
